import { Injectable } from '@nestjs/common';
import { PrismaService } from 'src/prisma/prisma.service';

@Injectable()
export class PrivilegiosService {
  constructor(private readonly prisma: PrismaService) {}

  findAll() {
    return this.prisma.privilegios.findMany({
      where: { active: true },
      orderBy: { created_at: 'asc' }, // usually constant list
    });
  }
}
